"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOneAsicsApi = void 0;
var _clientsApi = require("./clientsApi");
var _mfaApi = require("./mfaApi");
var _oauthApi = require("./oauthApi");
var _storesApi = require("./storesApi");
var _usersApi = require("./usersApi");
// 'slice' is the name of the slice that the token is in.
// 'tokenName' is the name of the token in the slice.
const createOneAsicsApi = _ref => {
  let {
    baseUrl,
    slice,
    tokenName,
    version = 'v2'
  } = _ref;
  const baseApiPath = `${baseUrl}/api/${version}`;
  return {
    baseApiPath,
    baseUrl,
    clientsApi: (0, _clientsApi.createClientsApi)({
      baseUrl: baseApiPath,
      slice,
      tokenName
    }),
    mfaApi: (0, _mfaApi.createMfaApi)({
      baseUrl: baseApiPath,
      slice,
      tokenName
    }),
    oauthApi: (0, _oauthApi.createOauthApi)({
      baseUrl: baseApiPath,
      slice,
      tokenName
    }),
    storesApi: (0, _storesApi.createStoresApi)({
      baseUrl: baseApiPath,
      slice,
      tokenName
    }),
    usersApi: (0, _usersApi.createUsersApi)({
      baseUrl: baseApiPath,
      slice,
      tokenName
    })
  };
};
exports.createOneAsicsApi = createOneAsicsApi;